// removed by extract-text-webpack-plugin
module.exports = {"player-wrapper":"VideoPlayer__player-wrapper","playerWrapper":"VideoPlayer__player-wrapper","react-player":"VideoPlayer__react-player","reactPlayer":"VideoPlayer__react-player"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/VideoPlayer/VideoPlayer.css
// module id = 1297
// module chunks = 8